export function gtag(...params) {
  if (typeof window.gtag === 'function') {
    window.gtag(...params);
  }
}

export function trackEvent(name, params) {
  gtag('event', name, params);
}
